// Credit of this component goes to the example of the react-truncate repo
import React from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';

export default class ExpandableContainer extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    lines: PropTypes.number,
    less: PropTypes.string,
    more: PropTypes.string,
  }

  static defaultProps = {
    lines: 3,
    more: 'read more',
    less: 'show less',
  }

  constructor(...args) {
    super(...args);

    this.state = {
      expanded: false,
      truncated: null,
      lines: this.props.lines,
    };

    this.handleTruncate = this.handleTruncate.bind(this);
    this.toggleLines = this.toggleLines.bind(this);
  }

  handleTruncate(truncated) {
    if (this.state.truncated !== truncated) {
      this.setState(state => {
        state.truncated = truncated;

        if (!truncated) {
          state.lines = false;
        }

        return state;
      });
    }
  }

  toggleLines(e) {
    e.preventDefault();

    this.setState(state => {
      state.expanded = !state.expanded;

      if (!state.expanded) {
        state.lines = this.props.lines;
      }

      return state;
    });
  }

  render() {
    const { expanded, truncated, lines } = this.state;

    return (
      <div className="readmore-container">
        <Truncate
          lines={!expanded && lines}
          ellipsis={(
            <span>
              ...
              <a className="readmore-more-anchor" href="#" onClick={this.toggleLines}>{this.props.more}</a>
            </span>
            )}
          onTruncate={this.handleTruncate}
        >
          {this.props.children}
        </Truncate>
        {!truncated && expanded && (
          <div className="showless">
            {' '}
            <a className="readmore-less-anchor" href="#" onClick={this.toggleLines}>{this.props.less}</a>
          </div>
        )}
      </div>
    );
  }
}
